import React from 'react';
import AdminPageLayout from '../components/admin/AdminPageLayout';
import PaymentManagement from '../components/admin/PaymentManagement';
import RecurringSchedulesPanel from '../components/admin/RecurringSchedulesPanel';

/**
 * Routed admin page for maid payment tracking. Wraps the existing
 * PaymentManagement component in the standard admin layout so it gets
 * the AppBar and dashboard breadcrumbs like /maid-profile.
 */
const PaymentManagementPage = () => (
  <AdminPageLayout
    title="Payment Management"
    subtitle="Track and manage technician payments per job assignment. Mark payouts as paid, adjust amounts, and rate performance."
    maxWidth="xl"
  >
    <PaymentManagement />
    <RecurringSchedulesPanel />
  </AdminPageLayout>
);

export default PaymentManagementPage;
